/* 复制文本 */
export function copyToClipboardOld(text: string) {
  // 创建一个临时textarea元素
  const textarea = document.createElement("textarea");
  // 将文本设置为textarea的值
  textarea.value = text;
  // 将textarea添加到文档中
  document.body.appendChild(textarea);
  // 选中textarea中的文本
  textarea.select();
  textarea.setSelectionRange(0, textarea.value.length); // 对于移动设备，确保选择区域
  // 执行复制命令
  const successful = document.execCommand("copy");
  // 移除临时textarea元素
  document.body.removeChild(textarea);
  if (successful) {
    console.log("文本已复制到剪贴板");
  } else {
    console.log("复制失败");
  }
}

/* base64轉文件流 */
export function base64ToFile(base64: any) {
  let date = new Date().getTime();
  let arr = base64.split(",");
  let type = arr[0].match(/:(.*?);/)[1];
  let suffix = type.split("/")[1];
  let fileName = `${date}.${suffix}`;
  let bstr = atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], fileName, { type });
}

/* 防抖 */
export function debounce<T extends (...args: any[]) => void>(
  func: T,
  delay: number
): (...args: Parameters<T>) => void {
  let timer: ReturnType<typeof setTimeout>;

  return function (...args: Parameters<T>) {
    // 清除之前的定时器
    if (timer) {
      clearTimeout(timer);
    }

    // 设置新的定时器
    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
}

/* 節流 */
export function throttle<T extends (...args: any[]) => void>(
  func: T,
  delay: number
): (...args: Parameters<T>) => void {
  let lastTime = 0;

  return function (...args: Parameters<T>) {
    const now = Date.now();
    if (now - lastTime >= delay) {
      func(...args);
      lastTime = now;
    }
  };
}

export function getQueryParams(): { [key: string]: string | string[] } {
  const urlParams = new URLSearchParams(window.location.search);
  const params: { [key: string]: string | string[] } = {};

  urlParams.forEach((value, key) => {
    if (params[key]) {
      if (Array.isArray(params[key])) {
        (params[key] as string[]).push(value);
      } else {
        params[key] = [params[key] as string, value];
      }
    } else {
      params[key] = value;
    }
  });

  return params;
}

export function compare(attribute: number) {
  return function (obj1: any, obj2: any) {
    var val1 = Number(obj1[attribute]);
    var val2 = Number(obj2[attribute]);
    if (val1 < val2) {
      return -1;
    } else if (val1 > val2) {
      return 1;
    } else {
      return 0;
    }
  };
}

// 旧版VIP规则颜色
// export function getVipColor() {
//   return {
//     "-1": "#c23bff",
//     0: "#e0e0e0",
//     1: "#e0e0e0",
//     2: "#e0e0e0",
//     3: "#e0e0e0",
//     4: "#e0e0e0",
//     5: "#e0e0e0",
//     6: "#e0e0e0",
//     7: "#e0e0e0",
//     8: "#e0e0e0",
//     9: "#e0e0e0",
//     10: "#e0e0e0",
//     11: "#75f6f0",
//     12: "#75f6f0",
//     13: "#75f6f0",
//     14: "#75f6f0",
//     15: "#75f6f0",
//     16: "#75f6f0",
//     17: "#75f6f0",
//     18: "#75f6f0",
//     19: "#75f6f0",
//     20: "#75f6f0",
//     21: "#67cbff",
//     22: "#67cbff",
//     23: "#67cbff",
//     24: "#67cbff",
//     25: "#67cbff",
//     26: "#67cbff",
//     27: "#67cbff",
//     28: "#67cbff",
//     29: "#67cbff",
//     30: "#67cbff",
//     31: "#ff66a3",
//     32: "#ff66a3",
//     33: "#ff66a3",
//     34: "#ff66a3",
//     35: "#ff66a3",
//     36: "#ff66a3",
//     37: "#ff66a3",
//     38: "#ff66a3",
//     39: "#ff66a3",
//     40: "#ff66a3",
//     41: "#ff9e47",
//     42: "#ff9e47",
//     43: "#ff9e47",
//     44: "#ff9e47",
//     45: "#ff9e47",
//     46: "#ff2b2b",
//     47: "#ff2b2b",
//     48: "#ff2b2b",
//     49: "#ff2b2b",
//     50: "#ff2b2b",
//     51: "#df5cff",
//     52: "#ffdb00",
//   };
// }

// 新版vip规则颜色
export function getVipColor() {
  return {
    "-1": "#c23bff",
    0: "#e0e0e0",
    1: "#e0e0e0",
    2: "#e0e0e0",
    3: "#e0e0e0",
    4: "#e0e0e0",
    5: "#e0e0e0",
    6: "#e0e0e0",
    7: "#e0e0e0",
    8: "#e0e0e0",
    9: "#e0e0e0",
    10: "#e0e0e0",
    11: "#75f6f0",
    12: "#75f6f0",
    13: "#75f6f0",
    14: "#75f6f0",
    15: "#75f6f0",
    16: "#75f6f0",
    17: "#75f6f0",
    18: "#75f6f0",
    19: "#75f6f0",
    20: "#75f6f0",
    21: "#67cbff",
    22: "#67cbff",
    23: "#67cbff",
    24: "#67cbff",
    25: "#67cbff",
    26: "#67cbff",
    27: "#67cbff",
    28: "#67cbff",
    29: "#67cbff",
    30: "#67cbff",
    31: "#ff66a3",
    32: "#ff66a3",
    33: "#ff66a3",
    34: "#ff66a3",
    35: "#ff66a3",
    36: "#ff66a3",
    37: "#ff66a3",
    38: "#ff66a3",
    39: "#ff66a3",
    40: "#ff66a3",
    41: "#ff9e47",
    42: "#ff9e47",
    43: "#ff9e47",
    44: "#ff9e47",
    45: "#ff9e47",
    46: "#ff9e47",
    47: "#ff9e47",
    48: "#ff9e47",
    49: "#ff9e47",
    50: "#ff9e47",
    51: "#ff2b2b",
    52: "#ff2b2b",
    53: "#ff2b2b",
    54: "#ff2b2b",
    55: "#ff2b2b",
    56: "#ff2b2b",
    57: "#ff2b2b",
    58: "#ff2b2b",
    59: "#ff2b2b",
    60: "#df5cff",
    61: "#df5cff",
    62: "#df5cff",
    63: "#df5cff",
    64: "#ffdb00",
    65: "#ffdb00",
    66: "#ffdb00",
  };
}

export function timeFormat(timeStamp?: number | string | Date): string {
  const obj: Date = timeStamp ? new Date(timeStamp) : new Date();

  const res: { [key: string]: number } = {
    y: obj.getFullYear(),
    m: obj.getMonth() + 1,
    d: obj.getDate(),
    h: obj.getHours(),
    i: obj.getMinutes(),
    s: obj.getSeconds()
  };

  const formattedRes: { [key: string]: string } = {};

  for (const key in res) {
    if (res.hasOwnProperty(key)) {
      formattedRes[key] = (res[key] < 10) ? `0${res[key]}` : `${res[key]}`;
    }
  }

  return `${formattedRes.y}-${formattedRes.m}-${formattedRes.d} ${formattedRes.h}:${formattedRes.i}:${formattedRes.s}`;
}

// 获取地址栏参数对象
export function handleQueryParams() {
  const params = new URLSearchParams(window.location.search);
  const paramsObject: Record<string, string> = {};

  // 将参数转换为对象  
  params.forEach((value, key) => {
    paramsObject[key] = value;
  });

  return paramsObject;
}

export const formatDate = (timestamp: number, format: string) => {
  // 创建一个 Date 对象  
  const date = new Date(timestamp);

  // 获取年份、月份和日期  
  const year = String(date.getFullYear());
  const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以加1  
  const day = String(date.getDate()).padStart(2, '0'); // 获取日期  
  const hours = String(date.getHours()).padStart(2, '0'); // 获取小时  
  const minutes = String(date.getMinutes()).padStart(2, '0'); // 获取分钟  
  const seconds = String(date.getSeconds()).padStart(2, '0'); // 获取秒  

  // 替换格式中的占位符  
  return format
    .replace('yyyy', year)
    .replace('MM', month)
    .replace('dd', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds);
}

// 是否为ios
export const isIos = () => {
  return /ios|iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
}

